import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getFinalState } from '../store/selectors/finalSelector';
import Final from '../Final';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import finalReducer from '../store/reducers/final';
import getAutoPlayMuteSetting from '@gameday/utils/selectors/getAutoPlayMuteSetting';

import { routes as WrapRoutes } from '../../Wrap/containers/WrapDataContainer';
import { routes as TeamSummaryMatchupRoutes } from '../../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import { routes as SummaryRoutes } from '../../Summary/containers/SummaryDataContainer';
import { routes as LineScoreRoutes } from '../../LineScore/containers/LineScoreDataContainer';
import { routes as DecisionRoutes } from '../../Decisions/containers/DecisionsDataContainer';
import { routes as AtBatRoutes } from '../../AtBat/containers/AtBatDataContainer';

import { switchActiveTab } from '../store/actions/final';
import useTracking from '@gameday/utils/hooks/useTracking';
import changeViewAction from '@gameday/app/lib/store/actions/views';
import { getPlayIndex } from '@gameday/utils/selectors/getPlayIndex';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

initContainerData.register({
    reducers: {
        final: finalReducer
    }
});

const actions = (dispatch, Tracking) => ({
    handleTabChange: (activeTab, tabIndex) => {
        dispatch(switchActiveTab(activeTab));
        if ((typeof tabIndex !== 'undefined')) {
            const cfg = {
                componentName: [activeTab],
                selectedIndex: tabIndex,
                text: activeTab,
                activity: 'Tab Click'
            };

            Tracking.track.track_click(cfg);
            Tracking.track.track_pageload();

            dispatch(changeViewAction({
                game_tab: activeTab?.toLowerCase(),
                game_view: 'final',
                detail: '',
                updateRoute: true
            }));
        }
    }
});

const routes = [{
    path: '/:teams?/:year?/:month?/:day?/:gamepk/final/:tab?/:detail?',
    exact: false,
    routes: [
        ...TeamSummaryMatchupRoutes,
        ...SummaryRoutes,
        ...WrapRoutes,
        ...LineScoreRoutes,
        ...DecisionRoutes,
        ...AtBatRoutes
    ]
}];

const FinalContainer = ({
    viewChangeHandler,
    showAtBatOverlay
}) => {
    const dispatch = useDispatch();
    const finalState = useSelector(getFinalState);
    const Tracking = useTracking();
    const retrievedAtBatPlayIndex = useSelector(getPlayIndex);
    const autoPlayMuteSetting = useSelector(getAutoPlayMuteSetting('final'));

    return (
        <ErrorBoundaryWrapper componentName='Final'>
            <Final
                showAtBatOverlay={ showAtBatOverlay }
                viewChangeHandler={ viewChangeHandler }
                retrievedAtBatPlayIndex={retrievedAtBatPlayIndex}
                { ...finalState }
                { ...actions(dispatch, Tracking) }
                { ...autoPlayMuteSetting }
            />
        </ErrorBoundaryWrapper>
    );
};

FinalContainer.propTypes = {
    viewChangeHandler: PropTypes.func,
    showAtBatOverlay: PropTypes.bool
};

export default FinalContainer;
export { routes };
